import styled from 'styled-components'

export const Container = styled.div`
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
`

export const TopContainer = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 16px;
  justify-content: space-between;
`

export const TitleContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;

  svg {
    max-height: 24px;
    min-height: 24px;
    max-width: 24px;
    min-width: 24px;
  }
`

export const Title = styled.p`
  color: #1D1D1D;
  font-size: 16px;
  font-weight: 700;

  @media (max-width: 600px) {
    font-size: 14px;
  }
`
